import React, { useState, useContext, useCallback } from 'react';
import Modal from 'semantic-ui-react/dist/commonjs/modules/Modal';
import MediaMinWidth from '../common/media_min_width';
import { breakpoints, mediaSizePolicy, sourceMediaSizeSpec } from './detail/content_card_params';
import ShownPopupsContext from '../../contexts/popups_context';
import ContextAwarePopup from './detail/context_aware_popup';
import {
  POPUP_MINIMUM_DELAY_BEFORE_SHOW_MS, POPUP_MINIMUM_SCROLL_BEFORE_SHOW_PX, POPUP_BACKOFF_SCHEDULE
} from './detail/general_params';
import UIMedia from '../ui/media';
import styled from 'styled-components';
import { isDesktop } from './detail/get_popup_media';

const aspectRatio = { w: 9, h: 16 };
const MODAL_WIDTH = 350;
const MODAL_HEIGHT = Math.floor(MODAL_WIDTH * aspectRatio.h / aspectRatio.w);
export const POPUP_TAG = 'all-video';

const AllVideoPopup = ({ webPopup, timeToAppear }) => {
  const [showing, setShowing] = useState(false);
  const shownPopupsContainer = useContext(ShownPopupsContext);

  const closePopup = useCallback(() => setShowing(false), []);

  return (
    <MediaMinWidth breakpoints={breakpoints}>
      {(...breakpointFlags) =>
        <ContextAwarePopup showing={showing} setShowing={setShowing} tag={POPUP_TAG}
          shownPopupsContainer={shownPopupsContainer} backoffPeriodSchedule={POPUP_BACKOFF_SCHEDULE}
          minimumDelayToShow={POPUP_MINIMUM_DELAY_BEFORE_SHOW_MS} shouldShowAutomatically='true'
          minimumScrollToShow={POPUP_MINIMUM_SCROLL_BEFORE_SHOW_PX} timeToAppear={timeToAppear}>
          <AllVideoModal open={showing} closeOnDocumentClick={false} closeOnDimmerClick={false} basic
            style={{ width: MODAL_WIDTH }} modalHeight={MODAL_HEIGHT}>
            <CrossButton onClick={closePopup}>&#10006;</CrossButton>
            <UIMedia mediaSizePolicy={mediaSizePolicy} sourceMediaSizeSpec={sourceMediaSizeSpec}
              media={isDesktop(breakpoints, breakpointFlags)
                ? webPopup.video.desktop_video_url
                : webPopup.video.mobile_video_url}
              breakpoints={breakpoints} breakpointFlags={breakpointFlags} fullScreen />
          </AllVideoModal>
        </ContextAwarePopup>}
    </MediaMinWidth>
  );
};

const AllVideoModal = styled(Modal)`
  div {
    height: ${props => props.modalHeight / 1.2}px;
  }
`;

const CrossButton = styled.span`
  position: absolute;
  z-index: 4;
  right: 0;
  margin: 10px 12px 0 0;
  font-size: 20px;
  cursor: pointer;
`;

export default AllVideoPopup;
